module.exports = __webpack_public_path__ + "img/TableActive.14944d97.svg";